import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

const Body = styled('div', {
  padding: '32px',

  p: {
    fontWeight: '800',
  },
});

const Wrapper = styled('div', {});

export const CommonModal = ({ children, heading, closeModal }) => {
  return (
    <Wrapper>
      <ModalDialog
        size="$md"
        header={heading}
        isOpen
        onClose={closeModal}
      >
        <Body>{children}</Body>
      </ModalDialog>
    </Wrapper>
  );
};

CommonModal.propTypes = {
  children: PropTypes.element,
  heading: PropTypes.string,
  closeModal: PropTypes.func,
};

CommonModal.defaultProps = {
  children: null,
  heading: '',
  closeModal: () => {},
};
